import React, { useState } from 'react';
import { X, Trash2, AlertTriangle } from 'lucide-react';
import '../Products/ProductModal.css';

const DeleteOrderModal = ({ order, onClose, onDelete }) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      await onDelete(order.id);
      onClose();
    } catch (error) {
      console.error('Error deleting order:', error);
      alert('Error al eliminar el pedido');
    } finally {
      setLoading(false);
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-content delete-modal">
        {/* Header */}
        <div className="modal-header delete-header">
          <div>
            <h2 className="modal-title">
              <AlertTriangle size={24} className="inline-icon" />
              Eliminar Pedido Semanal
            </h2>
            <p className="modal-subtitle">Esta acción no se puede deshacer</p>
          </div>
          <button 
            className="btn-icon" 
            onClick={onClose}
            type="button"
          >
            <X size={20} />
          </button>
        </div>

        {/* Body */}
        <div className="modal-body">
          <div className="delete-warning">
            <div className="warning-icon">
              <AlertTriangle size={48} />
            </div>
            <p className="warning-text">
              ¿Está seguro que desea eliminar este pedido?
            </p>
            <div className="product-details">
              <div className="detail-row">
                <span className="detail-label">Pedido:</span>
                <span className="detail-value">{order.orderNumber}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Cliente:</span>
                <span className="detail-value">{order.customerName}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Entrega:</span>
                <span className="detail-value">
                  {new Date(order.deliveryDate + 'T00:00:00').toLocaleDateString('es-CL')} - Semana {order.deliveryWeek}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-outline"
            onClick={onClose}
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleDelete}
            disabled={loading}
          >
            <Trash2 size={18} />
            {loading ? 'Eliminando...' : 'Eliminar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteOrderModal;
